import React from 'react';
import { Link } from 'react-router-dom';
import { getMediaUrl } from '../../utils/imageUtils';

const avatarFallback = '/images/avatar/DefaultProfile.jpg';

const QuotedPost = ({ post }) => {
  if (!post || !post.author) return null;

  return (
    <div className="mt-3 border-l-2 border-gray-300 pl-3">
      <div className="flex items-center space-x-2 mb-1">
        <Link to={`/profile/${post.author.username}`}>
          <img
            src={post.author.avatar ? getMediaUrl(post.author.avatar) : avatarFallback}
            alt={post.author.username}
            className="w-5 h-5 rounded-full"
            onError={(e) => {
              e.currentTarget.src = avatarFallback;
            }}
          />
        </Link>
        <Link
          to={`/profile/${post.author.username}`}
          className="font-semibold text-sm text-gray-700 hover:underline"
        >
          {post.author.username}
        </Link>
      </div>
      <p className="text-gray-600 text-sm line-clamp-3">{post.content}</p>
      {post.images && post.images.length > 0 && (
        <img
          src={getMediaUrl(post.images[0])}
          alt="Imagen citada"
          className="mt-2 w-24 h-24 object-cover rounded-lg"
        />
      )}
    </div>
  );
};

export default QuotedPost;
